/* eslint-disable */
import { createStyles, makeStyles } from "@material-ui/core";
import type { Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "480px",
      overflow: "hidden",
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    },
    closeBar: {
      height: "39px",
      borderBottom: "1px solid #e9e9e9",
      padding: "10px 10px 10px 25px",
      display: "flex",
      boxSizing: "content-box",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    closeIcon: {
      transform: "scale(0.6)",
      filter: "drop-shadow(0px 0px 1px black)",
    },
    content: {
      padding: "0 17px 20px 25px",
      overflowX: "hidden",
      overflowY: "auto",
      height: "100%",
    },
    contentTitle: {
      padding: "20px 0 10px 0",
      fontSize: "18px",
      fontWeight: "bold",
    },
    contentBody: {
      fontSize: "13px",
      lineHeight: 1.5,
    },
    contentMoreInformation: {
      fontSize: "13px",
      lineHeight: "20px",
      textDecoration: "underline",
    },

    accordionRoot: {},
    accordionSummary: {
      fontSize: "14px",
      fontWeight: 700,

      padding: "12px 15px 12px 20px",
      display: "flex",
      flexDirection: "row-reverse",
    },

    confirmBar: {
      borderTop: "1px solid #d8d8d8",
      height: "98px",
      width: "480px",
      background: theme.palette.common.white,
    },
    confirmButton: {
      textShadow: "0 0px black",
      letterSpacing: '1px',
      margin: "19px 25px 10px 25px",
      width: "210px",
      fontSize: "12px",
      fontWeight: "bold",
      height: "36px",
      background: "#E0E9F2",
      textTransform: "capitalize",
      transition: "opacity: .3s",
      opacity: 1,
      "&:hover": {
        opacity: 0.7,
        background: "#E0E9F2ы",
        transition: "opacity: .3s",
      },
    },
    confirmLogo: {
      height: "30px",
      background: "#f4f4f4",
      display: 'flex',
      justifyContent: 'flex-end',
      paddingTop: '5px',
      paddingRight: '10px',
    },
  })
);
